import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["diagnosticRangeForm", "ribbon", "chart", "graphIcon"];

  updateDiagnosticRange() {
    this.diagnosticRangeFormTarget.requestSubmit();
  }

  changeView() {
    this.ribbonTarget.classList.toggle("hidden");
    this.chartTarget.classList.toggle("hidden");
    [
      "border-indicators-purple-primary",
      "bg-indicators-purple-secondary",
      "border-action-border",
      "hover:border-indicators-purple-primary",
      "hover:bg-indicators-purple-secondary",
      "hover:border-action-border",
      "hover:bg-transparent"
    ].forEach(className => this.graphIconTarget.classList.toggle(className));
  }
}
